<template>
  <div class="form-page">
    <h3 class="text-white text-center pt-5">Add a New Book</h3>
    <form
      @submit.prevent="handleSubmit"
      class="form d-flex flex-column bg-white"
    >
      <label for="title" class="text-white mb-1">Book title:</label>
      <input type="text" name="title" v-model="title" required class="mb-3" />

      <label for="author" class="text-white mb-1">Book author:</label>
      <input type="text" name="author" v-model="author" required class="mb-3" />

      <label for="review" class="text-white mb-1">My review:</label>
      <textarea
        type="textarea"
        name="review"
        v-model="review"
        class="mb-3 review"
        rows="4"
      ></textarea>

      <button class="btn btn-warning">Add Book</button>
    </form>
  </div>
</template>

<script>
import { ref } from "vue";
import getUser from "../composables/getUser";
import { useRouter } from "vue-router";

// firebase imports
import { db } from "../firebase/config";
import { addDoc, collection } from "firebase/firestore";

export default {
  setup() {
    const { user } = getUser();
    const router = useRouter();

    const title = ref("");
    const author = ref("");
    const review = ref("");
    const handleSubmit = async () => {
      const colRef = collection(db, "books");
      await addDoc(colRef, {
        title: title.value,
        author: author.value,
        review: review.value,
        isFav: false,
        userUid: user.value.uid,
      });
      router.push("/");
    };
    return { handleSubmit, title, author, review };
  },
};
</script>

<style>
.form-page {
  background-image: url(../assets/bg2.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 50px;

  height: 100vh;
  overflow: hidden;
}
.form {
  margin: 0 auto;
  margin-top: 50px;
  width: 30rem;
  max-width: 90%;
  border-radius: 5px;
  position: relative;
  z-index: 1;
  background: inherit;
  overflow: hidden;
  padding: 20px;
}

.form::before {
  content: "";
  position: absolute;
  background: inherit;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.1);
  filter: blur(10px);
  margin: -20px;
}
</style>
